<template>
  <v-dialog eager persistent open-on-focus scrollable light
    @keydown.esc="choice(false)"
    :value="value"
    :max-width="width"
    :overlay-color="overlayColor"
    :overlay-opacity="overlayOpacity"
    :class="classNames"
  >
    <v-card tile
      :max-height="height"
    >
      <v-toolbar dense flat dark
        v-if="Boolean(title)"
        :color="titleColor"
        :light="isLighted"
      >
        <v-icon v-if="Boolean(icon)" left>{{ icon }}</v-icon>
        <v-toolbar-title v-text="$i18n.translate(title)"/>
      </v-toolbar>

      <v-card-text v-if="Boolean(message)" v-html="message" class="pa-3"></v-card-text>
      <v-card-text v-else class="pa-3">
        <v-container fluid class="-container" >
          <v-row dense align="start" justify="start">
            <slot></slot>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text
          v-if="Boolean(buttonTrueText)"
          :color="buttonTrueColor"
          @click="choice(true)"
          class="c-dialog-btn"
        >
          {{ $i18n.translate(buttonTrueText) }}
        </v-btn>
        <v-btn text
          v-if="Boolean(buttonFalseText)"
          :color="buttonFalseColor"
          @click="choice(false)"
          class="-dialog-btn"
        >
          {{ $i18n.translate(buttonFalseText) }}
        </v-btn>
        <v-spacer v-if="buttonPosition === 'center'"></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    buttonTrueText: {
      type: String,
      default: '',
    },
    buttonFalseText: {
      type: String,
      default: '',
    },
    buttonTrueColor: {
      type: String,
      default: 'primary',
    },
    buttonFalseColor: {
      type: String,
      default: 'grey',
    },
    titleColor: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    width: {
      type: Number,
      default: 450,
    },
    height: {
      type: Number,
      default: 250,
    },
    overlayColor: {
      type: String,
      default: '#212121',
    },
    overlayOpacity: {
      type: String,
      default: '0.46',
    },
    buttonPosition: {
      type: String,
      default: 'right',
      validator(value) {
        return ['center', 'right'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      value: false,
    };
  },
  mounted() {
    // document.addEventListener('keyup', this.onEnterPressed);
  },
  destroyed() {
    // document.removeEventListener('keyup', this.onEnterPressed);
  },
  computed: {
    classNames() {
      return `c-modal-dialog ${this.class}`;
    },
    isLighted() {
      return !this.$vuetify.theme.dark;
    },
  },
  methods: {
    open() {
      this.value = true;
    },
    close() {
      this.value = false;
    },
    onEnterPressed(e) {
      if (e.keyCode === 13) {
        e.stopPropagation();
        this.choice(true);
      }
    },
    choice(selected) {
      this.value = false;
      this.$emit('closed', selected);
      this.$destroy();
    },
    // eslint-disable-next-line no-unused-vars
    // changed(res) {
    //   this.value = false;
    //   this.$destroy();
    // },
  },
};
</script>
<style scoped>
.c-modal-dialog .-dialog-btn {
  text-transform: none !important;
}
</style>
